import React from "react";

const Well = ({ children }) => {

    return (
        <div className="c-well">
            {children}
        </div>
    )
};

export default Well;



// WEBPACK FOOTER //
// ./src/components/Well.js